module.exports = __webpack_public_path__ + "img/bgAllyship@2x.2ffca239.jpg";